module.exports = __webpack_public_path__ + "img/1-2.bdfd72b7.svg";